module.exports = __webpack_public_path__ + "img/resource-ky.4bbf9ca0.png";